const headers = {
    Authorization: 'Bearer 70922e34873dfed84653001a2a746aa2060420231680794166'
}

export default headers;